module.exports = "/_next/static/images/game-3-menu-slide-2-d4bb311433aeb562bf115083e08ac5e5.png";